import { computed, unref, type MaybeRef } from 'vue';
import { useQueries } from '@tanstack/vue-query';

import { mapOffersResults } from '@/shared/lib';

import { getHotRoutesQueryOptions } from './hot-routes';

export function useAllRoutesQuery({
  origCityCode,
  destCitiesCodes,
}: {
  origCityCode: MaybeRef<string>;
  destCitiesCodes: MaybeRef<string[] | null>;
}) {
  const queries = useQueries({
    queries: computed(() => {
      const origCity = unref(origCityCode);
      const destCities = unref(destCitiesCodes);

      if (!destCities || destCities.length === 0 || !origCity) return [];

      return destCities.map(dest =>
        getHotRoutesQueryOptions({
          origCityCode: origCity,
          destCityCode: dest,
        }),
      );
    }),
  });

  return computed(() => {
    return queries.map(query => ({
      results: query.data?.data.results.map(mapOffersResults),
      isLoading: query.isLoading,
    }));
  });
}
